import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, OnInit, TemplateRef, inject, input } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, map } from 'rxjs';
import {
  FeatureAvailability,
  FeatureWithAvailability,
  SubscriptionState,
} from 'src/app/store/subscription/subscription.state';
import { NotAvailableInPlanComponent } from './components/not-available-in-plan.component';

interface VM {
  feature?: FeatureWithAvailability;
}

@Component({
  selector: 'app-feature-wrapper',
  templateUrl: './feature-wrapper.component.html',
  imports: [NgTemplateOutlet, NotAvailableInPlanComponent, AsyncPipe],
})
export class FeatureWrapperComponent implements OnInit {
  private store = inject(Store);

  // used in the template
  public Availability = FeatureAvailability;

  readonly featureName = input<string>();

  readonly childComponent = input<TemplateRef<any>>();
  readonly notAvailableInPlanComponent = input<TemplateRef<any>>();

  vm$?: Observable<VM>;

  ngOnInit(): void {
    this.vm$ = this.store
      .select(SubscriptionState.feature(this.featureName()!))
      .pipe(
        map(feature => {
          return {
            feature: feature,
          };
        })
      );
  }
}
